import React from 'react'
import PropTypes from 'prop-types'
import {ContentTabs} from 'hec/components/content-tabs'
import {cn} from '@/lib/utils'
//These are being exported here temp. just update the imports in customComponents index.ts
export {BuilderTabButtonBox, TabButtonBoxDefinition} from './tab-button'
export {BuilderTabPanelBox, TabPanelBoxDefinition} from './tab-panel'

const textBlock = (text) => ({
    '@type': '@builder.io/sdk:Element',
    component: {
        name: 'Text',
        options: {
            text
        }
    }
})

const tabButtonBlock = (text) => ({
    '@type': '@builder.io/sdk:Element',
    component: {
        name: 'Tab Button',
        options: {
            content: [textBlock(text)]
        }
    }
})

const tabPanelBlock = (text) => ({
    '@type': '@builder.io/sdk:Element',
    component: {
        name: 'Tab Panel',
        options: {
            content: [textBlock(text)]
        }
    }
})

export const CustomContentTabs = ({
    items,
    defaultTab,
    builderBlock,
    attributes,
    'data-testid': dataTestId
}) => {
    const {className, ...restAttributes} = attributes || {}

    return (
        <ContentTabs
            items={items}
            defaultTab={defaultTab}
            builderBlock={builderBlock}
            className={cn('w-full', className)}
            {...restAttributes}
            data-testid={dataTestId || 'contentTabs-ContentTabs'}
        />
    )
}

CustomContentTabs.propTypes = {
    items: PropTypes.array,
    defaultTab: PropTypes.number,
    builderBlock: PropTypes.object,
    attributes: PropTypes.object,
    'data-testid': PropTypes.string
}

export const ContentTabsDefinition = {
    component: CustomContentTabs,
    name: 'v1: Content Tabs',
    noWrap: true,
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    defaultStyles: {
        width: '100%'
    },
    inputs: [
        {
            name: 'defaultTab',
            type: 'number',
            defaultValue: 1,
            min: 1,
            helperText: 'The tab active on page load'
        },
        {
            name: 'items',
            type: 'list',
            defaultValue: [
                {
                    triggerBlocks: [tabButtonBlock('Tab')],
                    panelBlocks: [tabPanelBlock('Panel content')]
                },
                {
                    triggerBlocks: [tabButtonBlock('Tab')],
                    panelBlocks: [tabPanelBlock('Panel content')]
                }
            ],
            subFields: [
                {
                    name: 'triggerBlocks',
                    friendlyName: 'Tab Button',
                    type: 'uiBlocks',
                    defaultValue: [tabButtonBlock('Tab')],
                    helperText:
                        'Visual content for the tab button. Use text, image, box, or icon. Avoid nested buttons or links.'
                },
                {
                    name: 'panelBlocks',
                    friendlyName: 'Tab Panel',
                    type: 'uiBlocks',
                    defaultValue: [tabPanelBlock('Panel content')],
                    helperText: 'Any content for the tab panel.'
                }
            ]
        }
    ]
}
